import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@common/checkbox";
import { useExportData } from "@planzone/view-models";
import { ExportsDataTypes, ExportsFormats } from "@planzone/dto";

import { Props } from "./types";
import { Button } from "@common/button";
import { DateTimeInput } from "@common/dateTimeInput";
import styles from "./styles.scss";

function ResourceUsageReport(props: Props) {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const { isRequestPending, exportData } = useExportData();
  const now = new Date();
  const [startDate, setStartDate] = React.useState(
    new Date(
      now.getFullYear(),
      now.getMonth() - 1,
      now.getDate(),
    ).toISOString(),
  );
  const [endDate, setEndDate] = React.useState(
    new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString(),
  );

  return (
    <div
      className={classNames(styles.wbsReport, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.row}>
        <div
          className={styles.checkbox}
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox isChecked={isChecked} />
        </div>
        <div className={styles.col}>
          <h2 className={styles.name}>
            {t("planzoneParametersPage.resourceUsageReport.title")}
          </h2>
          <p className={styles.description}>
            {t("planzoneParametersPage.resourceUsageReport.subTitle")}
          </p>
        </div>
        {isChecked && (
          <Button
            className={styles.button}
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() => {
              exportData({
                fileName: props.fileName,
                author: props.author,
                data: {
                  type: ExportsDataTypes.RESOURCES_USAGE_REPORT,
                  data: {
                    planzone: props.planzone,
                    startDate: startDate,
                    endDate: endDate,
                  },
                },
                format: ExportsFormats.EXCEL,
              });
            }}
          >
            {t("planzoneParametersPage.resourceUsageReport.download")}
          </Button>
        )}
      </div>
      {isChecked && (
        <div className={styles.filters}>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("planzoneParametersPage.resourceUsageReport.startDate")}
            </h3>
            <DateTimeInput
              dateTime={startDate}
              placeholder={t(
                "planzoneParametersPage.resourceUsageReport.startDate",
              )}
              calendarPosition="TOP"
              input={setStartDate}
            />
          </div>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("planzoneParametersPage.resourceUsageReport.endDate")}
            </h3>
            <DateTimeInput
              dateTime={endDate}
              placeholder={t(
                "planzoneParametersPage.resourceUsageReport.startDate",
              )}
              calendarPosition="TOP"
              input={setEndDate}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export { ResourceUsageReport };
